/**
 * Routes whiteboard app messages to the correct handler by studentId.
 * Extracted for testability.
 */

import { MESSAGE_TYPES } from './constants';

/**
 * Route a whiteboard app message to the handler for the given studentId.
 * @param {{ data: object, fromId?: string }} message - Raw app-message event
 * @param {{ current: Record<string, function> }} handlersRef - Ref holding studentId -> handleReceive
 * @param {(message: object) => void} [onTutorStoreUpdate] - If provided (e.g. tutor), called for every whiteboard message so store can stay in sync for non-focused students
 * @returns {boolean} True if message was a whiteboard type (handled or skipped)
 */
export function routeWhiteboardMessage(message, handlersRef, onTutorStoreUpdate) {
  const data = message?.data;
  if (!data || typeof data !== 'object') return false;

  const wbType = data.type;
  if (
    wbType !== MESSAGE_TYPES.STROKE &&
    wbType !== MESSAGE_TYPES.ERASE &&
    wbType !== MESSAGE_TYPES.CLEAR &&
    wbType !== MESSAGE_TYPES.LAYOUT &&
    wbType !== MESSAGE_TYPES.ACTIVATE &&
    wbType !== MESSAGE_TYPES.CURSOR
  ) {
    return false;
  }

  const studentId = data.studentId;
  if (!studentId || typeof studentId !== 'string') return true;

  if (wbType !== MESSAGE_TYPES.CURSOR && typeof onTutorStoreUpdate === 'function') {
    try {
      onTutorStoreUpdate(message);
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('[whiteboard] onTutorStoreUpdate error:', err);
      }
    }
  }

  const handler = handlersRef?.current?.[studentId];

  if (handler) {
    try {
      handler(message);
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('[whiteboard] handleReceive error:', err);
      }
    }
  }
  return true;
}
